import React, { useState } from "react";
import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Box, Button, Grid, IconButton, Typography, Card, CardMedia, CardActions } from '@mui/material';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";


RHFFileUploadField.propTypes = {
    name: PropTypes.string,
    helperText: PropTypes.node,
    value: PropTypes.string
};


export default function RHFFileUploadField({ name, helperText, values = [], readOnly = true, label, multiple = true, accept = "image/*", onFilesChange, maxFiles = 10, ...other }) {
    const { control } = useFormContext();

    const [files, setFiles] = useState(values);

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files || []);

        // Limit files if maxFiles is set
        const newFiles = [...files, ...selectedFiles].slice(0, maxFiles);

        setFiles(newFiles);
        if (onFilesChange) onFilesChange(newFiles);
    };

    const handleRemove = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
        if (onFilesChange) onFilesChange(updatedFiles);
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <>
                    <Box>
                        <Typography variant="subtitle1" sx={{ mb: 1 }} style={{ float: 'left', paddingRight: 10, paddingTop: 5 }}>
                            {label}
                        </Typography>

                        <Button
                            variant="contained"
                            component="label"
                            startIcon={<CloudUploadIcon />}
                            sx={{ mb: 2 }}
                        >
                            Choose Files
                            <input
                                type="file"
                                hidden
                                multiple={multiple}
                                accept={accept}
                                onChange={handleFileChange}
                            />
                        </Button>

                        {files.length > 0 && (
                            <Grid container spacing={2}>
                                {files.map((file, index) => (
                                    <Grid item xs={6} sm={4} md={3} key={index}>
                                        <Card
                                            sx={{
                                                position: "relative",
                                                borderRadius: 2,
                                                boxShadow: 3,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <CardMedia
                                                component="img"
                                                src={URL.createObjectURL(file)}
                                                alt={file.name}
                                                sx={{
                                                    height: 140,
                                                    objectFit: "cover",
                                                }}
                                            />
                                            <CardActions
                                                sx={{
                                                    justifyContent: "space-between",
                                                    px: 1,
                                                    py: 0.5,
                                                    bgcolor: "rgba(0,0,0,0.5)",
                                                    position: "absolute",
                                                    bottom: 0,
                                                    width: "100%",
                                                    color: "white",
                                                }}
                                            >
                                                <Typography
                                                    variant="caption"
                                                    noWrap
                                                    sx={{ maxWidth: "80%" }}
                                                >
                                                    {file.name}
                                                </Typography>
                                                {!readOnly ?
                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={() => handleRemove(index)}
                                                        sx={{
                                                            bgcolor: "rgba(255,255,255,0.2)",
                                                            "&:hover": { bgcolor: "rgba(255,0,0,0.4)" },
                                                        }}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                    : null
                                                }
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </Box>
                </>
            )}
        />
    );
}